var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18,3.5C17.9,3.5,17.9,3.5,18,3.5c-0.1,0-0.1,0.1-0.2,0.1c-1.7,0.9-3.4,1.8-5.1,2.7c0,0-0.1,0-0.1,0.1l0,0V5.8 c0-0.4,0-0.7,0-1c0-1.3-0.9-2.3-2.2-2.3c-2.7,0-5.4,0-8.1,0C0.9,2.5,0,3.5,0,4.8c0,2.5,0,5.3,0,8.4c0,0.2,0,0.4,0.1,0.6 c0.2,1.1,1.1,1.7,2.1,1.7c1.4,0,2.7,0,4.1,0c0.7,0,1.3,0,2,0h2c0.1,0,0.1,0,0.2,0c1,0,1.9-0.9,2-1.9c0-0.4,0-0.8,0-1.2 c0-0.2,0-0.4,0-0.5c0,0,0-0.1,0-0.1v0l0,0c0,0,0.1,0,0.1,0.1l1.7,0.9c1.1,0.6,2.3,1.2,3.4,1.8c0,0,0.1,0,0.1,0.1c0,0,0,0,0.1,0l0,0 L18,3.5L18,3.5z M16.5,5.9v6.2l0,0c0,0-0.1,0-0.1,0l-0.7-0.4c-1-0.5-2.1-1.1-3.1-1.6c-0.1,0-0.1-0.1-0.1-0.2c0-0.6,0-1.1,0-1.7 c0-0.1,0-0.1,0.1-0.2c1-0.5,2-1,2.9-1.5L16.5,5.9C16.5,6,16.5,5.9,16.5,5.9C16.5,5.9,16.5,5.9,16.5,5.9z M11,4.8c0,2.8,0,5.5,0,8.3 c0,0.5-0.3,0.8-0.8,0.8h-8c-0.5,0-0.8-0.3-0.8-0.8V4.8C1.5,4.3,1.7,4,2.2,4h8C10.7,4,11,4.3,11,4.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOn);
export default __webpack_public_path__ + "static/media/videoOn.590ca825e6a811a940f152efb4970492.svg";
export { ForwardRef as ReactComponent };